import React, { useEffect, useMemo, useState } from "react";
import { Step1 } from "../step1/Step1";
import icons from "bootstrap-italia/dist/svg/sprites.svg";
import { Step3 } from "../step3/Step3";
import { Step2 } from "../step2/Step2";
import { Step4 } from "../step4/Step4";
import axios from "axios";
import AuthUser from "../../../backend/pages/AuthUser";
import { Step5 } from "../step5/Step5";
import { Link } from "react-router-dom";
import { cleanService } from "../../../utils/storageFunc";
import { BASE_URL } from "../../../server";
import getHeaders from "../../../utils/handleHeaderFunc";
import sha256 from "crypto-js/sha256";

const Wizard = () => {
  const [appointmentsConfirmed, setAppointmentsConfirmed] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [savedOffice, setSavedOffice] = useState(
    sessionStorage.getItem("selectedOffice") || ""
  );
  const [savedService, setSavedService] = useState(
    sessionStorage.getItem("selectedService") || ""
  );
  const [savedBlockId, setSavedBlockId] = useState(
    sessionStorage.getItem("selectedBlockId") || ""
  );
  const [selectedSlots, setSelectedSlots] = useState(
    JSON.parse(sessionStorage.getItem("selectedSlots")) || []
  );
  const [details, setDetails] = useState("");
  const { http, setToken } = AuthUser();
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // NEW: overlay/spinner stato
  const [isBooking, setIsBooking] = useState(false);

  const isValidStep1 = useMemo(() => {
    return !!savedOffice && !!savedService;
  }, [savedOffice, savedService]);

  const isValidStep2 = useMemo(() => {
    return !!savedBlockId;
  }, [savedBlockId]);

  const isValidStep4 = useMemo(() => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return (
      !!firstname &&
      !!lastname &&
      !!phoneNumber &&
      !!email &&
      emailPattern.test(email.trim())
    );
  }, [firstname, lastname, phoneNumber, email]);

  const validateStep4Form = () => {
    if (!firstname || !lastname || !email || !phoneNumber) {
      setError("Inserisci nome, cognome, email e telefono.");
      return false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email.trim())) {
      setError("Inserisci un indirizzo email valido.");
      return false;
    }

    return true;
  };

  const handleNext = () => {
    setCurrentStep(currentStep + 1);
    window.scrollTo(0, 0);
  };

  const handleNextWithSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!validateStep4Form()) {
      return;
    }

    console.log("submitting form");
    const submitttedForm = await submitForm(
      e,
      firstname,
      lastname,
      phoneNumber,
      pin,
      email
    );
    if (submitttedForm) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  };

  const stepSet = (step) => {
    setCurrentStep(step);
  };

  const submitForm = async (
    e,
    firstname,
    lastname,
    phoneNumber,
    pin,
    email
  ) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    let randomPin = Math.floor(100000 + Math.random() * 900000);
    let trimmedPin = "";
    try {
      if (!pin) {
        trimmedPin = randomPin;
      } else {
        trimmedPin = pin?.trim();
      }
      const trimmedFirstname = firstname?.trim().toLowerCase();
      const trimmedLastname = lastname?.trim().toLowerCase();
      const trimmedPhoneNumber = phoneNumber?.trim();
      const trimmedEmail = email?.trim().toLowerCase();
      const dataToHash = `${trimmedFirstname}${trimmedLastname}${trimmedPhoneNumber}${trimmedPin}`;
      const hashedData = sha256(dataToHash).toString();
      const token = btoa(`${hashedData}:${hashedData}`);

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Basic ${token}`,
      };
      // Prima richiesta di login con il valore di isRegistrazione corrente
      let login = await axios.post(
        `${BASE_URL}/user/login`,
        { registration: false },
        { headers }
      );

      // Se il response indica "Utente non registrato", riprova con registration: true
      if (login.data && login.data.esito === 99 && login.data.client_id === 0) {
        login = await axios.post(
          `${BASE_URL}/user/login`,
          { registration: true },
          { headers }
        );
        console.log("Retry login with registration true:", login);
      }

      if (login?.data?.profile && login?.data?.profile?.id) {
        sessionStorage.setItem("user", JSON.stringify(login.data.profile));
        sessionStorage.setItem("basic_token", token);
        sessionStorage.setItem("client_id", login.data.profile.id);

        try {
          const apiUrl = `${BASE_URL}/update_user`;
          const updateHeaders = {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
          };
          const data = {
            profile: {
              id: login.data.profile.id,
              firstname,
              lastname,
              email,
              phone: phoneNumber,
              competence_id: 4,
            },
          };
          const response = await axios.put(apiUrl, data, {
            headers: updateHeaders,
          });
          if (response.status === 200) {
            sessionStorage.setItem(
              "user",
              JSON.stringify({
                ...login.data.profile,
                firstname,
                lastname,
                email,
                phone: phoneNumber,
              })
            );
            return true;
          } else {
            setError("Login fallito. Verifica le tue credenziali.");
          }
        } catch (error) {
          console.error(error);
          setError("Si è verificato un errore durante il login.");
        } finally {
          setLoading(false);
        }
      } else {
        setError("Login fallito. Verifica le tue credenziali.");
      }
    } catch (error) {
      console.error(error);
      setError("Si è verificato un errore durante il login.");
    }
    setLoading(false);
  };

  const booking = async () => {
    // NEW: mostra overlay/spinner
    setIsBooking(true);

    // booking without PROXY
    const apiUrl = `${BASE_URL}/booking`;
    const clientId = JSON.parse(sessionStorage.getItem("user")).id;
    const officeServiceId = sessionStorage.getItem("officeServiceId");
    const blockId = sessionStorage.getItem("selectedBlockId");

    const requestBody = {
      client_id: clientId,
      office_service_id: officeServiceId,
      block_id: blockId,
      note: details,
    };

    try {
      const headers = getHeaders();
      const response = await axios.put(apiUrl, requestBody, {
        headers: headers,
      });
      if (response.status === 200) {
        // pulisco sessionStorage
        cleanService();
        // pulisco state del wizard
        setSavedOffice("");
        setSavedService("");
        setSavedBlockId("");
        setSelectedSlots([]);
        setDetails("");

        setAppointmentsConfirmed(true);

        // salvo il booking_id in sessionStorage
        sessionStorage.setItem("bookingId", response.data.booking_id);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        setToken(null);
        window.location.href = "/prenotazione-appuntamento/login";
      }
    } finally {
      // NEW: nascondi overlay/spinner
      setIsBooking(false);
    }
  };

  const handleButtonBookingClick = () => {
    booking();
  };

  return (
    <div className="container">
      {/* NEW: Overlay + Spinner */}
      {isBooking && (
        <div className="booking-overlay">
          <div className="booking-spinner">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Caricamento...</span>
            </div>
          </div>
        </div>
      )}

      <div className="steppers">
        <div className="steppers-header">
          <ul>
            <StepButton
              step={1}
              currentStep={currentStep}
              stepSet={stepSet}
              icons={icons}
            />
            <StepButton
              step={2}
              currentStep={currentStep}
              stepSet={stepSet}
              icons={icons}
            />
            <StepButton
              step={3}
              currentStep={currentStep}
              stepSet={stepSet}
              icons={icons}
            />
            <StepButton
              step={4}
              currentStep={currentStep}
              stepSet={stepSet}
              icons={icons}
            />
            <StepButton
              step={5}
              currentStep={currentStep}
              stepSet={stepSet}
              icons={icons}
            />
            <span className="steppers-index" aria-hidden="true">
              {`${currentStep}/5`}
            </span>
          </ul>
        </div>
      </div>

      {currentStep === 1 && (
        <div>
          {/*<OfficeServiceSelect onValid={() => setIsValidStep1(true)} />*/}
          {/*       <Step1 onValid={() => setIsValidStep1(true)} /> */}
          <Step1
            savedOffice={savedOffice}
            savedService={savedService}
            setSavedOffice={setSavedOffice}
            setSavedService={setSavedService}
          />
          <div className="flex justify-end mt-4">
            <button
              className="btn btn-primary"
              onClick={handleNext}
              disabled={!isValidStep1 || isBooking}
            >
              Avanti
            </button>
          </div>
        </div>
      )}

      {currentStep === 2 && (
        <div>
          <Step2
            savedBlockId={savedBlockId}
            setSavedBlockId={setSavedBlockId}
            selectedSlots={selectedSlots}
            setSelectedSlots={setSelectedSlots}
          />
          <div className="flex justify-between mt-4">
            <button
              className="btn btn-primary mr-3 "
              onClick={handlePrev}
              disabled={isBooking}
            >
              Indietro
            </button>
            <button
              className="btn btn-primary"
              disabled={!isValidStep2 || isBooking}
              onClick={handleNext}
            >
              Avanti
            </button>
          </div>
        </div>
      )}

      {currentStep === 3 && (
        <div>
          <Step3 details={details} setDetails={setDetails} />
          <div className="flex justify-between mt-4">
            <button
              className="btn btn-primary mr-3"
              onClick={handlePrev}
              disabled={isBooking}
            >
              Indietro
            </button>
            <button
              className="btn btn-primary"
              onClick={handleNext}
              disabled={isBooking}
            >
              Avanti
            </button>
          </div>
        </div>
      )}
      {currentStep === 4 && (
        <div>
          <Step4
            firstname={firstname}
            setFirstname={setFirstname}
            lastname={lastname}
            setLastname={setLastname}
            email={email}
            setEmail={setEmail}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            pin={pin}
            setPin={setPin}
            isValidStep4={isValidStep4}
          />
          {error && <div className="alert alert-danger">{error}</div>}
          <div className="flex justify-between mt-4">
            <button
              className="btn btn-primary mr-3"
              onClick={handlePrev}
              disabled={isBooking}
            >
              Indietro
            </button>
            <button
              className="btn btn-primary"
              onClick={(e) => handleNextWithSubmit(e)}
              disabled={!isValidStep4 || isBooking}
            >
              Avanti
            </button>
          </div>
        </div>
      )}
      {currentStep === 5 && (
        <div>
          <Step5
            appointmentsConfirmed={appointmentsConfirmed}
            setAppointmentsConfirmed={setAppointmentsConfirmed}
            stepSet={stepSet}
          />

          {!appointmentsConfirmed ? (
            <div className="flex justify-between mt-4">
              <button
                className="btn btn-primary mr-3"
                onClick={handlePrev}
                disabled={isBooking}
              >
                Indietro
              </button>
              <button
                className="btn btn-primary"
                onClick={handleButtonBookingClick}
                disabled={isBooking}
              >
                Conferma
              </button>
            </div>
          ) : (
            <div className="flex justify-between mt-4">
              <button
                className="btn btn-primary mr-3"
                onClick={() => {
                  cleanService();
                  setAppointmentsConfirmed(false);
                  setCurrentStep(1);
                }}
                disabled={isBooking}
              >
                Nuovo appuntamento
              </button>
              <a className="btn btn-primary" href="/prenotazione-appuntamento">
                Torna alla home
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Wizard;

const StepButton = ({ step, currentStep, stepSet, icons }) => {
  /*   const isConfirmed =
    step <= currentStep ? (
      <>
        <svg className="icon icon-white steppers-success w-[1.778rem!important] h-[1.778rem!important]">
          <use href={`${icons}#it-check`} />
        </svg>
        <span className="visually-hidden">Confermato</span>
      </>
    ) : (
      <>
        <span className="visually-hidden">Step </span>
        {step}
      </>
    ); */

  const isActive = currentStep === step ? "active no-line" : "";

  return (
    <li
      className={`steppers-step ${isActive} ${
        step <= currentStep ? "confirmed" : ""
      } ${
        step === currentStep ? "lg:border-b-4 border-primary bg-red-300" : ""
      }}`}
    >
      <div
        className={"flex items-center justify-center"}
        /*   onClick={() => stepSet(step)} */
      >
        {/*    <span
          className="hidden lg:inline-block
        steppers-number"
        >
          {isConfirmed}
        </span> */}
        {step === 1
          ? "Luogo"
          : step === 2
          ? "Data e orario"
          : step === 3
          ? "Dettagli appuntamento"
          : step === 4
          ? "Richiedente"
          : "Riepilogo"}
      </div>

      {step < currentStep && (
        <>
          <svg
            className="icon steppers-success w-[1.778rem!important] h-[1.778rem!important]"
            aria-hidden="true"
          >
            <use href={`${icons}#it-check`}></use>
          </svg>
          <span className="visually-hidden">Confermato</span>
        </>
      )}
    </li>
  );
};
